import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Globe } from 'lucide-react';
import './Registrationfee.css'; // Using SAME CSS as Banktype for styling

const url = process.env.REACT_APP_BACKEND_URL;

const EditRegistrationfee = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const [data, setData] = useState({
    amount: "",
    name: ""
  });

  useEffect(() => {
    const fetchFee = async () => {
      try {
        const response = await axios.get(`${url}/api/registerfee/${id}`);
        setData({
          amount: response.data.data.amount,
          name: response.data.data.name || ""
        });
      } catch (error) {
        toast.error("Failed to load Registration Fee data");
        navigate('/ViewRegistrationFee');
      }
    };

    fetchFee();
  }, [id, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.put(`${url}/api/registerfee/${id}`, {
        amount: data.amount,
        name: data.name
      });

      if (response.data.success) {
        toast.success("Registration Fee updated successfully!");
        navigate('/ViewRegistrationFee');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update Registration Fee");
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="form-wrapper">
      <div className="country-form-container">
        <h2 className="form-title">
          <Globe size={20} className="inline mr-2" /> Edit Registration Fee
        </h2>

        <form className="country-form" onSubmit={handleSubmit}>
          {/* Fee Amount */}
          <div className="form-field filled">
            <input
              type="number"
              name="amount"
              value={data.amount}
              onChange={handleChange}
              required
            />
            <label>Fee Amount</label>
          </div>

          {/* name */}
          <div className="form-field filled">
            <input
              type="text"
              name="name"
              value={data.name}
              onChange={handleChange}
            />
            <label>name</label>
          </div>

          <div className="button-group">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate('/ViewRegistrationFee')}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="submit-btn"
              disabled={submitting}
            >
              {submitting ? "Updating..." : "Update Fee"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default EditRegistrationfee;
